module.exports = __webpack_public_path__ + "static/media/ConnectSlack.9bc28650.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ConnectSlack.gif
// module id = 1000
// module chunks = 0